<template>
	<div class="add-edit-dialog">
		<el-dialog
		  title="创建邀请码"
		  :visible.sync="show"
		  :before-close="_close"
		  :close-on-click-modal="false"
		>
			<el-row>
				<el-col>
					<el-form class="myform" :model="formData" :rules="formRule" ref="ruleForm" label-width="110px">
			
						<el-form-item label="场景名称" prop="scene_name">
							<div class="form-item">
								<el-input class="bill_input" v-model.trim="formData.scene_name"  placeholder="输入场景名称" maxlength="25">
								</el-input>
							</div>
						</el-form-item>
			
						<el-form-item label="邀请编号前缀" prop="prefix">
							<div class="form-item">
								<el-input class="bill_input"  @change="handleChangePrefix" v-model="formData.prefix" placeholder="5个以内英文字母、数字、下划线" maxlength="5">
								</el-input>
							</div>
						</el-form-item>
						
						<el-form-item label="生成邀请码数" prop="create_num">
							<div class="form-item">
								<el-input-number v-model="formData.create_num" @change="handleChangeNum" :min="1" :max="10"></el-input-number>
							</div>
						</el-form-item>
			
						<div class="form-handle">
							<el-button type="infor" @click="_close()">取消</el-button>
							<el-button type="primary" @click="_save('ruleForm')" :loading="submiting">立即创建</el-button>
						</div>
					</el-form>
				</el-col>
			</el-row>
		
		</el-dialog>
	</div>
</template>

<script>
	import {
		createInviteqr
	} from '@/api/point';
	import area from '@/assets/js/area.js';
	
	export default {
		data() {
			return {
				submiting: false,
				formData: {
					scene_name: '',
					prefix: '',
					create_num: '',
				},
				formRule: {
					scene_name: [{
						required: true,
						message: '请输入场景名称',
					}],
					prefix: [{
						required: true,
						message: '请输入邀请编号前缀'
					}],
					create_num: [{
						required: true,
						message: '请输入生成邀请码数',
					}]
				},
			};
		},
		props: {
			show: {
				type: Boolean,
				default: false
			}
		},
		watch:{
			show: function(){
				
			}
		},
		methods: {
			_save(){
				var that = this;
				var info = that.formData;
				if (this.submiting) {
					return false;
				}
				
				that.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						var prefixStr = '';
						if(info.create_num > 1){
							prefixStr += info.prefix + '001-';
							prefixStr += info.prefix + info.create_num.toString().padStart(3,'0');
						}else{
							prefixStr = info.prefix + '001';
						}
					
						this.$confirm('您是否要生成编号为'+prefixStr+'的邀请码？', '提示', {
							confirmButtonText: '确认',
							cancelButtonText: '取消',
							confirmButtonClass:'confrim-btn'
						}).then(() => {
							that.submiting = true; 
							createInviteqr(info).then(res => {
								if (res.code == 0) {
									that._clear();
									that.$emit('success');
								}else{
									that.$message.error(res.message);
									that.submiting = false;
								}
							})
						})
						
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			_close() {
				this._clear();
				this.$emit('close');
			},
			_clear(){
				this.submiting = false;
				this.$refs['ruleForm'].resetFields();
			},
			handleChangeNum(event) {
				var value = '' + event;
				value = value.replace(/\s/g, "");
				value = num(value);
				this.formData['create_num'] = value;
			},
			handleChangePrefix(val){
				var value = '' + val;
				value = value.replace(/\s/g, "");
				value = prefixStr(value);
				this.formData['prefix'] = value;
			},
		},
		mounted() {
		}
	}
	function num(value) {
		var regex = /^[1-9]\d*$/;		
		
		if (!regex.test(value)) {
			return '';
		}
		return value;
	}
	function prefixStr(value){
		var regex = /^[a-zA-Z0-9_]+$/;
		
		if (!regex.test(value)) {
			return '';
		}
		return value;
	}
	
</script>

<style scoped>
	.add-edit-dialog >>> .el-dialog__body {
		padding-top: 0;
		padding-bottom: 16px;
		overflow-x: auto;
		font-size: 14px;
	}
	.add-edit-dialog >>> .el-dialog {
		width: 445px;
	}
	.add-edit-dialog >>> .el-row{
		margin-top: 20px;
	}
	.add-edit-dialog >>> .el-form-item__error{
		left: 20px;
	}
	
	.add-edit-dialog >>> .el-form-item__label{
		font-weight: bold;
		margin-right: 10px;
	}
	.add-edit-dialog >>> .bill_input{
		width: 284px;
	}
	.add-edit-dialog >>> .form-handle{
		text-align: right;
		margin-top: 30px;
	}
	.add-edit-dialog >>> .el-textarea__inner{
		height: 77px;
	}
</style>